module.exports = __webpack_public_path__ + "static/media/bg.957d4c85.jpg";